import { createReducer } from 'deox';
import { Paging, Currency, Status } from '@/types';
import { fetchCurrenciesActions } from '@/redux/actions/country-information/currencies';

export interface CurrenciesState {
  data?: Currency[];
  paging: Paging;
  status: Status;
}

const initialState: CurrenciesState = {
  data: undefined,
  paging: {
    pageNumber: 0,
    pageSize: 0,
    totalRecords: 0,
  },
  status: {
    code: '',
    message: '',
  },
};

const countryInformationCurrenciesReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchCurrenciesActions.success, (state, { payload }) => {
    const { data, paging, status } = payload;
    return {
      ...state,
      data,
      paging,
      status,
    };
  }),
]);

export default countryInformationCurrenciesReducer;
